import _ from 'lodash';

export const requiredTextInput = (message: any) =>
    (value: any) => _.trim(value).length > 0 ? undefined : message;
